import React from 'react';
import { batch, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const LeftMenu = () => {
  const navigate = useNavigate();
  const setApp = useDispatch();
  const { sbBlock } = useSelector(state => state.sb);
  const { studyID } = useSelector(state => state.studyDetail);

  const clicked = (block) => {
    batch(() => {
      setApp({ type: '_FILTERED', payload: ['label', null] });
      setApp({ type: '_SIDEBAR', payload: ['sbBlock', block] });
      setApp({ type: '_STUDY_DETAIL', payload: ['studyTitle', null] });
      setApp({ type: '_STUDY_DETAIL', payload: ['studyID', []] });
      setApp({ type: '_MARKERS_INIT' });

      navigate(block === 'init' ? '/' : `/${block.toLowerCase()}`);
    });
  };
  const isStudyDetail = studyID && studyID?.length && studyID[0] > 0;
  return (
    <div id="left-menu">
      <button
        className={sbBlock === 'init' && !isStudyDetail ? 'active' : ''}
        onClick={() => clicked('init')}
      >
        Studies
      </button>

      <button
        className={sbBlock === 'Species' && !isStudyDetail ? 'active' : ''}
        onClick={() => clicked('Species')}
      >
        Species
      </button>

      <button
        className={sbBlock === 'Countries' && !isStudyDetail ? 'active' : ''}
        onClick={() => clicked('Countries')}
      >
        Countries
      </button>

      <button
        className={sbBlock === 'References' && !isStudyDetail ? 'active' : ''}
        onClick={() => clicked('References')}
      >
        References
      </button>

      <button
        className={sbBlock === 'Search' && !isStudyDetail ? 'active' : ''}
        onClick={() => clicked('Search')}
      >
        Search
      </button>
    </div>
  );
};

export default LeftMenu;
